import ApiClient from '@assets/js/front/checkout/api/ApiClient';
export default new ApiClient(process.env.MIX_API_URL, { 'X-RefererSearch': window.location.search });
